// ./src/core/lobby/HUD.tsx
import React, { useState, useEffect } from 'react';
import { GameHeader } from './Header';
import { ChatWidget } from './ChatWidget';
import { ConnectionStatusOverlay } from '@core/UI/overlayelements/ConnectionStatusOverlay';
import { BetHistoryModal } from '@core/UI/overlayelements/BetHistoryModal';
import { GlobalBus, UI_DISMISS_POPUPS } from '@core/Bus/EventBus';
import { OPEN_BET_HISTORY } from '@core/Bus/betHistoryEvents';
import { getGameFromUrl } from '@core/utils/urlParser';

function hasGameParam() {
  return new URLSearchParams(location.search).has('game');
}

function isSkySniffer() {
  const game = getGameFromUrl();
  return game === 'skysniffer' || game === 'sky-sniffer';
}

// Styles to ensure the HUD container is on top and interactive
const hudStyles: React.CSSProperties = {
  position: 'relative',
  zIndex: 2000,
  pointerEvents: 'none',
};

const childStyles: React.CSSProperties = {
  pointerEvents: 'auto',
};

export const HUD: React.FC = () => {
  const [inGame, setInGame] = useState(hasGameParam());
  const [hideHeader, setHideHeader] = useState(isSkySniffer());
  const [isBetHistoryOpen, setBetHistoryOpen] = useState(false);

  useEffect(() => {
    const onNav = () => {
      setInGame(hasGameParam());
      setHideHeader(isSkySniffer());
    };
    window.addEventListener('playgrid:navigation', onNav as any);
    return () =>
      window.removeEventListener('playgrid:navigation', onNav as any);
  }, []);

  useEffect(() => {
    const openBetHistory = () => setBetHistoryOpen(true);
    const unsubOpen = GlobalBus.on(OPEN_BET_HISTORY, openBetHistory);
    const unsubDismiss = GlobalBus.on(UI_DISMISS_POPUPS, () =>
      setBetHistoryOpen(false)
    );
    return () => {
      unsubOpen();
      unsubDismiss();
    };
  }, []);

  if (inGame) {
    return (
      <div style={hudStyles}>
        <div style={childStyles}>
          {!hideHeader && <GameHeader />}
          <ChatWidget />
        </div>

        {/* ✅ ADDED: Always show connection overlay when in game */}
        <ConnectionStatusOverlay />
        <BetHistoryModal
          isOpen={isBetHistoryOpen}
          onClose={() => setBetHistoryOpen(false)}
        />
      </div>
    );
  }

  return null;
};
